// extracted by mini-css-extract-plugin
export default {"container":"TableCellEditor-module__container--Jqjsc","editor":"TableCellEditor-module__editor--fWl01"};